// useToast.js
import { useCallback } from "react";
import Swal, { SweetAlertIcon } from "sweetalert2";
import "../index.scss";

const Toast = Swal.mixin({
  toast: true,
  position: "center",
  iconColor: "white",
  customClass: {
    popup: "colored-toast",
  },
  showConfirmButton: false,
  timer: 1500,
  timerProgressBar: true,
});

export function useToast() {
  const showToast = useCallback(
    async (icon: SweetAlertIcon = "info", title = "") => {
      await Toast.fire({
        icon,
        title,
      });
    },
    []
  );

  return { showToast };
}
